import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

import Title from '~/components/modules/text/title';
import Subhead from '~/components/modules/text/subhead';

const JumbotronVariant = {
	green: 'bg-tufh-green-750',
	purple: 'bg-tufh-violet-850',
	red: 'bg-tufh-red-550'
};

const YrbsJumbotron = ({
	variant = 'green',
	title,
	subtitle,
	description,
	image,
	imageAlt,
	imageClasses,
	imageContainerStyles,
	imageStyles,
	className,
	contentClasses,
	...imgProps
}) => {
	const data = useStaticQuery(graphql`
		query YrbsJumbotronQuery {
			image: allFile(filter: {
				name: {}, dir: {regex: "/jumbotron/"}
			}) {
				edges {
					node {
						id
						name
						childImageSharp {
							gatsbyImageData(
								width: 1920
							)
						}
					}
				}
			}
		}
	`);

	return (
		<section
			className={`
				relative grid grid-cols-1 grid-rows-[1fr,auto] md:grid-rows-1 overflow-hidden md:min-h-[25rem] xl:min-h-[20rem]
				${JumbotronVariant[variant]}
				${className ?? ''}
			`}
		>
			<div
				className="order-last md:order-first md:row-span-full md:col-span-full grid md:items-center relative z-20 container mx-auto p-4"
			>
				<div
					className={`
						md:w-1/2
						${image ? 'relative z-10' : 'relative'}
						${contentClasses ?? ''}
					`}
				>
					{subtitle &&
						<Subhead
							className="!mb-4"
						>
							{subtitle}
						</Subhead>
					}

					<Title
						as="h1"
						size="text-3xl md:text-4xl"
						className="mb-8"
					>
						{title}
					</Title>

					{description &&
						<p className="text-pretty">{description}</p>
					}
				</div>
			</div>

			{image &&
				<div className="relative md:row-span-full md:col-span-full">
					{image &&
						<GatsbyImage
							image={data.image.edges.filter(img => img.node.name === image)[0].node.childImageSharp.gatsbyImageData}
							alt={imageAlt ?? ''}
							style={imageContainerStyles}
							imgStyle={imageStyles}
							objectPosition="50% 0%"
							className={`
								w-full h-full object-cover object-top
								${imageClasses ?? ''}
							`}
							{...imgProps}
						/>
					}
				</div>
			}
		</section>
	);
};

export default YrbsJumbotron;
